module.exports = __webpack_public_path__ + "img/sign_220310571_1.6021f8cb.png";